import { Fragment } from 'react';
import { FloatingPortal } from '@floating-ui/react';
export const PORTAL_ID = 'tetris-portal';
export const TOAST_PORTAL_ID = 'tetris-toast-portal';
export function PortalProvider() {
    return (<Fragment>
      <FloatingPortal id={PORTAL_ID}/>
      <FloatingPortal id={TOAST_PORTAL_ID}/>
    </Fragment>);
}
